
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Wakadtomumbaicab() {



    const cardData =
    {
        keyword: '  Wakad to Mumbai Cab ',
        heading: 'Skyline Cabs: Wakad to Mumbai Cab ',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Wakad to Mumbai Cab services. Whether you are heading to Mumbai for business, leisure, or an airport transfer, our fleet of well-maintained vehicles and experienced drivers ensure a smooth, safe, and timely ride. With competitive fares and top-notch customer service, Skyline Cabs provides a hassle-free journey from Wakad to Mumbai. Book your ride with us today for a comfortable and convenient travel experience.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Wakad to Mumbai Cab",
      "description": "Skyline Cabs offers comfortable and reliable taxi services from Wakad to Mumbai. Whether you're heading for business or leisure, we provide timely and convenient rides with various vehicle options such as Innova and Ertiga."
    },
    {
      "name": "Wakad to Mumbai Airport Cab",
      "description": "Book your airport transfer from Wakad to Mumbai Airport with Skyline Cabs. Choose from a range of vehicles like Innova Crysta or Ertiga for a smooth and comfortable ride to Chhatrapati Shivaji International Airport."
    },
    {
      "name": "Wakad to Dadar Cab",
      "description": "Skyline Cabs provides a convenient and affordable cab service from Wakad to Dadar, ensuring a comfortable ride to one of Mumbai’s busiest neighborhoods with well-maintained vehicles."
    },
    {
      "name": "Taxi Wakad to Mumbai International Airport",
      "description": "Travel in comfort with Skyline Cabs for your ride from Wakad to Mumbai International Airport. We offer affordable and reliable transportation with professional drivers to ensure you reach your destination on time."
    },
    {
      "name": "Wakad to Mumbai Domestic Airport Cab Fare",
      "description": "Skyline Cabs offers affordable and transparent fare structures for trips from Wakad to Mumbai Domestic Airport. Enjoy a comfortable ride with a range of vehicle options available at competitive rates."
    },
    {
      "name": "Wakad to Mumbai Innova Taxi Fare",
      "description": "For a premium ride from Wakad to Mumbai, choose an Innova taxi from Skyline Cabs. Spacious and comfortable, the Innova is the perfect choice for family or group travel, ensuring a smooth and comfortable journey."
    },
    {
      "name": "Wakad to Borivali Cab",
      "description": "Skyline Cabs offers affordable taxi services from Wakad to Borivali. Whether you are traveling for business or leisure, we ensure a safe and comfortable ride to one of Mumbai's popular suburban areas."
    },
    {
      "name": "Wakad to Mumbai Ertiga Taxi",
      "description": "Choose Skyline Cabs' Ertiga taxi service for a comfortable and affordable ride from Wakad to Mumbai. Perfect for families or small groups, the Ertiga offers a spacious and smooth ride."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers convenient and timely airport transfers from Pune to Mumbai. Choose from various vehicle options, including Innova and Ertiga, to ensure a smooth and comfortable journey."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "For a budget-friendly yet comfortable ride from Pune to Mumbai, book an Ertiga with Skyline Cabs. Ideal for small groups or families, the Ertiga offers a spacious and comfortable ride."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Skyline Cabs offers premium Innova cab services from Pune to Mumbai. The Innova is ideal for groups or family travel, offering ample space and a smooth ride for your journey."
    },
    {
      "name": "Wakad to Mumbai Cab Booking Online",
      "description": "Book your Wakad to Mumbai cab with Skyline Cabs easily through our online booking platform. Get a wide selection of vehicles like Innova, Ertiga, and others for a comfortable and hassle-free ride."
    },
    {
      "name": "Wakad to Mumbai Airport Cab Charges",
      "description": "Skyline Cabs offers transparent and competitive pricing for your ride from Wakad to Mumbai Airport. Our fares are affordable, and we ensure high-quality service throughout your journey."
    },
    {
      "name": "Wakad to Andheri Cab Charges",
      "description": "Skyline Cabs provides affordable and reliable taxi services from Wakad to Andheri. Choose from various vehicle options, including Innova and Ertiga, to enjoy a smooth and comfortable ride."
    },
    {
      "name": "Wakad to Dadar Cabs",
      "description": "Skyline Cabs offers easy and affordable taxi services from Wakad to Dadar. Our cabs are well-maintained and our drivers are experienced, ensuring a smooth and timely ride."
    },
    {
      "name": "Wakad to Navi Mumbai Cabs",
      "description": "Skyline Cabs provides reliable taxi services from Wakad to Navi Mumbai. Choose from a wide range of vehicles to suit your needs, and travel in comfort to this popular region of Mumbai."
    },
    {
      "name": "Wakad to Navi Mumbai Innova Crysta",
      "description": "For a luxurious and comfortable ride from Wakad to Navi Mumbai, book the Innova Crysta with Skyline Cabs. Ideal for families or groups, it offers ample space and a smooth ride."
    },
    {
      "name": "Cab Service in Wakad",
      "description": "Skyline Cabs offers reliable and affordable taxi services within Wakad, Pune. Whether you need a local ride or an intercity trip, we ensure prompt and comfortable service."
    },
    {
      "name": "Taxi Service in Wakad Pune",
      "description": "Skyline Cabs offers dependable taxi services in Wakad, Pune. With various vehicle options and professional drivers, we cater to your local and intercity travel needs."
    },
    {
      "name": "Best Car Service in Wakad",
      "description": "Skyline Cabs provides the best car service in Wakad, Pune. Whether you need a quick local ride or a long-distance trip, our fleet of well-maintained vehicles is ready to serve you."
    },
    {
      "name": "Pune Wakad Innova Crysta on Rent",
      "description": "Rent an Innova Crysta from Skyline Cabs in Wakad, Pune, for a luxurious travel experience. Ideal for business or family trips, this vehicle offers comfort and style."
    },
    {
      "name": "Pune Mumbai Skyline Cabs",
      "description": "Skyline Cabs offers reliable taxi services from Pune to Mumbai, ensuring a comfortable and timely journey. Choose from a range of vehicles like Innova and Ertiga for your travel needs."
    },
    {
      "name": "Best Cab Service in Wakad Pune",
      "description": "Skyline Cabs offers the best cab service in Wakad, Pune. Whether you need a ride for work or leisure, we provide dependable and affordable taxi services tailored to your needs."
    }
  ],
  "tableData": [
    ["Wakad to Mumbai Cab", "Wakad to Mumbai Airport Cab"],
    ["Wakad to Dadar Cab", "Taxi Wakad to Mumbai International Airport"],
    ["Wakad to Mumbai Domestic Airport Cab Fare", "Wakad to Mumbai Innova Taxi Fare"],
    ["Wakad to Borivali Cab", "Wakad to Mumbai Ertiga Taxi"],
    ["Pune to Mumbai Airport Cab", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Wakad to Mumbai Cab Booking Online"],
    ["Wakad to Mumbai Airport Cab Charges", "Wakad to Andheri Cab Charges"],
    ["Wakad to Dadar Cabs", "Wakad to Navi Mumbai Cabs"],
    ["Wakad to Navi Mumbai Innova Crysta", "Cab Service in Wakad"],
    ["Taxi Service in Wakad Pune", "Best Car Service in Wakad"],
    ["Pune Wakad Innova Crysta on Rent", "Pune Mumbai Skyline Cabs"],
    ["Best Cab Service in Wakad Pune", ""]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Wakad to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable, on-time cab services from Wakad to Mumbai, ensuring that you can rely on us for smooth and hassle-free travel. Whether it’s for business, leisure, or an airport transfer, we make sure you reach your destination comfortably and promptly."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in comfort with Skyline Cabs’ fleet of clean, spacious, and well-maintained vehicles. From economical sedans to spacious SUVs and luxury cars, we have a range of options to suit your travel needs, ensuring a smooth and enjoyable journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, courteous, and experienced in navigating the route from Wakad to Mumbai. They are familiar with local traffic patterns and the best routes, ensuring a safe, efficient, and comfortable ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive pricing for your Wakad to Mumbai journey with a clear, upfront fare structure. No hidden charges or unexpected costs—just straightforward pricing that makes your travel affordable and easy to plan."
    },
    {
        "WhyChooseheading": "24/7 Availability for Wakad to Mumbai Travel",
        "WhyChoosedescription": "Skyline Cabs is available around the clock, meaning you can book a cab from Wakad to Mumbai whenever you need it. Whether you need an early morning ride or a late-night pick-up, we are always ready to serve you."
    },
    {
        "WhyChooseheading": "Variety of Vehicle Options for Every Need",
        "WhyChoosedescription": "Whether you're traveling solo, with a group, or have a lot of luggage, we have a vehicle that fits your needs. Choose from a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars, all in excellent condition for your comfort."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking a cab from Wakad to Mumbai is simple and quick through our website or mobile app. Get instant booking confirmation, view your fare estimate, and track your ride in real-time for a smooth experience."
    },
    {
        "WhyChooseheading": "Safe, Secure, and Comfortable Travel",
        "WhyChoosedescription": "Your safety is our top priority. All our cabs are GPS-enabled for real-time tracking, and our drivers are background-checked for your peace of mind. Whether traveling for work or leisure, you can trust Skyline Cabs for a secure and comfortable journey."
    }
]










    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Wakad to Mumbai with Skyline Cabs?',
            answer:
                'Booking your cab is quick and easy! You can use our website, mobile app, or simply call our customer service. Enter your pickup location in Wakad and drop location in Mumbai, choose your vehicle, and confirm your booking instantly.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Wakad to Mumbai travel?',
            answer:
                'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Choose according to your travel group size, preferences, and comfort requirements.',
        },
        {
            id: 3,
            question: 'Is the fare from Wakad to Mumbai fixed or calculated based on distance?',
            answer:
                'Skyline Cabs offers fixed, transparent pricing for all rides. The fare includes tolls, taxes, and any additional charges, all of which are communicated upfront during the booking process.',
        },
        {
            id: 4,
            question: 'Can I book a one-way or round-trip cab from Wakad to Mumbai?',
            answer:
                'Yes, you can book both one-way and round-trip cabs. Just choose your preferred travel option and provide the necessary details when booking.',
        },
        {
            id: 5,
            question: 'How long does the journey from Wakad to Mumbai take?',
            answer:
                'Typically, the journey takes 3 to 3.5 hours, depending on traffic conditions. Our experienced drivers ensure you arrive safely and on time.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced and reliable?',
            answer:
                'Yes, all of our drivers are thoroughly vetted, experienced in long-distance travel, and trained to provide a safe and comfortable ride. You can trust us for a smooth experience from Wakad to Mumbai.',
        },
        {
            id: 7,
            question: 'Can I schedule a Wakad to Mumbai cab in advance?',
            answer:
                'Absolutely! You can schedule your ride in advance via our app or website. We recommend booking ahead for peak hours or weekends to ensure the best vehicle availability.',
        },
        {
            id: 8,
            question: 'Do you offer airport drop-off services from Wakad to Mumbai?',
            answer:
                'Yes, we provide direct cab services from Wakad to Mumbai Domestic and International Airports. Just let us know your flight details, and we will ensure you reach the airport on time.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my Wakad to Mumbai booking?',
            answer:
                'Yes, we offer easy modifications and cancellations through our app or website. Our customer service team is also available for assistance.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for Wakad to Mumbai?',
            answer:
                'Skyline Cabs offers a reliable, comfortable, and cost-effective ride. We focus on customer satisfaction, providing experienced drivers, transparent pricing, and well-maintained vehicles for a hassle-free journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rohit Malhotra",
            rating: 5,
            review: "I had a wonderful experience traveling from Wakad to Mumbai with Skyline Cabs. The car was clean, the driver was punctual, and the journey was smooth. I’ll definitely choose Skyline Cabs for my next trip!"
        },
        {
            name: "Miss. Priya Shinde",
            rating: 4,
            review: "The ride was very comfortable, and the driver was friendly. The only thing that could improve is the availability of snacks or drinks in the car, but other than that, it was a great experience!"
        },
    ];
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wakad to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/wakad-to-mumbai-cab.jpg",
  "description": "Book Wakad to Mumbai cab service with Skyline Cabs for a smooth, timely, and budget-friendly ride. Choose AC sedans or SUVs with verified drivers for one-way or round-trip journeys available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7634"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/wakad-to-mumbai-cab-service"
  }
};


      
    
      

    return (
        <div>

<Helmet>
  <title>Wakad to Mumbai Cab Service | One-Way & Round Trip | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Wakad to Mumbai cab service with Skyline Cabs for a smooth, timely, and budget-friendly ride. Choose AC sedans or SUVs with verified drivers for one-way or round-trip journeys available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Wakad to Mumbai Cab Service, Cab from Wakad to Mumbai, One-Way Taxi Wakad to Mumbai, Round Trip Cab Wakad to Mumbai, AC Cab Wakad to Mumbai, SUV Taxi Wakad to Mumbai, Affordable Cab Service Wakad to Mumbai, Skyline Cabs Wakad to Mumbai, Online Cab Booking Wakad to Mumbai, 24/7 Cab Wakad to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Wakadtomumbaicab;